import { useMutation } from '@tanstack/react-query'

import { ProjectUpdateType } from './project-drawer'

import { useQueryClient } from '@tanstack/react-query'
import { Project } from 'interfaces/project'
import { request } from 'lib/api/fetch-api'
import IconButton from 'lib/components/buttons/icon-button'
import { Drawer } from 'lib/components/drawer/drawer'
import { toast } from 'sonner'
import { ArrowLeftIcon } from 'lucide-react'
import AddDeliverablesTable from 'components/elements/projects/add-deliverables-table'
import { DrawerState } from './project-drawer'

interface DeliverablesContentProps {
  project: Project
  setDrawerState: (state: DrawerState) => void
  setOpen: (open: boolean) => void
  onUpdate: (project: Project, action: ProjectUpdateType) => void
}

export default function AddDeliverablesContent({
  project,
  setDrawerState,
  setOpen,
  onUpdate,
}: DeliverablesContentProps) {
  const trimmedProjectName = project?.name?.length > 40 ? `${project?.name?.substring(0, 40)}...` : project?.name
  const onFinished = (update = true) => {
    if (update) {
      onUpdate(project, ProjectUpdateType.UPDATE)
    }
    setDrawerState('details')
  }

  const queryClient = useQueryClient()

  const addTicketsToProjectMutation = useMutation({
    mutationFn: (ticketIds: number[]) =>
      request({
        endpoint: 'addTicketsToProject',
        query: { id: project.id },
        body: { ticket_ids: ticketIds },
      }),
    onSuccess: () => {
      toast.success('Requests added to project')
      queryClient.invalidateQueries({ queryKey: ['projectDeliverables', project.id] })
      onFinished()
    },
    onError: (e) => {
      toast.error('Error adding requests to project')
      console.error('Error adding requests to project', e)
    },
  })

  return (
    <>
      <Drawer.Header setOpen={setOpen} showCloseButton={false} className="tw-static">
        <div className="tw-flex tw-items-center tw-gap-4">
          <IconButton
            size="xs"
            color="transparent"
            onClick={() => setDrawerState('details')}
            className="tw-mr-2"
            data-testid="BackButton"
          >
            <ArrowLeftIcon className="tw-text-neutral-700" />
          </IconButton>
          <h3 className="tw-m-0 tw-p-0">Add Requests to &quot;{trimmedProjectName}&quot;</h3>
        </div>
      </Drawer.Header>
      <Drawer.Body className="tw-pb-0 tw-pt-4">
        <div className="tw-mt-4">
          <AddDeliverablesTable
            projectId={project.id}
            onFinished={onFinished}
            handleAddDeliverables={addTicketsToProjectMutation.mutate}
            enableRowSelection={(row) => row.original.project?.id !== project.id}
            isChecked={(row) => row.original.project?.id === project.id}
          />
        </div>
      </Drawer.Body>
    </>
  )
}
